import React from "react";
import { injectIntl } from "react-intl";
import {
  RIGHTS_STATE_UNASSIGNED,
  RIGHTS_STATE_NOT_REQUIRED,
  RIGHTS_STATE_VALID,
  RIGHTS_STATE_EXPIRING,
  RIGHTS_STATE_EXPIRED
} from "../../constants/rights-constants";

// Mapea rightsState -> clase/label. "mixed" (rollup de una carpeta con más
// de un estado presente) y "na" (fuera del módulo) no son rightsState reales
// del backend — son estados de UI propios de esta pantalla.
const CONFIG = {
  [RIGHTS_STATE_UNASSIGNED]: { cls: "un", id: "rights_state_unassigned" },
  // Gris, no ámbar: es una decisión tomada, no algo que pida atención.
  [RIGHTS_STATE_NOT_REQUIRED]: { cls: "nr", id: "rights_state_not_required" },
  [RIGHTS_STATE_EXPIRED]: { cls: "ex", id: "rights_state_expired" },
  [RIGHTS_STATE_EXPIRING]: { cls: "so", id: "rights_state_expiring" },
  [RIGHTS_STATE_VALID]: { cls: "ok", id: "rights_state_valid" },
  mixed: { cls: "mix", id: "rights_state_mixed" },
  na: { cls: "na", id: "rights_state_na" }
};

const RightsStateTag = ({ state, intl }) => {
  if (!state) {
    return <span className="rm-tag na">{intl.formatMessage({ id: CONFIG.na.id })}</span>;
  }
  const config = CONFIG[state] || CONFIG.mixed;
  const hasDot = config.cls !== "mix" && config.cls !== "na";

  return (
    <span className={`rm-tag ${config.cls}`}>
      {hasDot && <span className="d" />}
      {intl.formatMessage({ id: config.id })}
    </span>
  );
};

export default injectIntl(RightsStateTag);
